<template>
  <div class="">
    <div class="column box adjust-height">
      <div class="title">Virtual Lobbies</div>
      <div  class="dropdown" style="width: 500px" :class="{'is-active' : openTemplateDropdown}" @click="openTemplateDropdown=!openTemplateDropdown">
          <div class="dropdown-trigger">
            <button class="button is-small" aria-haspop="true" aria-controls="dropdown-menu">
              <span class="selected-type">{{ selectedLobby.name }}</span>
              <span class="icon is-small">
                <i class="fal fa-angle-down" aria-hidden="true"></i>
              </span>
            </button>
          </div>
          <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content">
              <a v-for="(lobby, index) in lobbies" :key="index" class="dropdown-item" :class="{'is-active' : selectedLobby === lobby}" @click="selectedLobby = lobby">
                <span>{{lobby.name}}</span>
              </a>
            </div>
          </div>
        </div>
    </div>
    <div v-if="this.selectedLobby.path">
      <button @click="goEdit()">Edit</button>
      <button @click="goView(selectedLobby)">Go To</button>
    </div>
  </div>
</template>
<script>
import admin from '@/api/admin'

export default {
  components: {
  },
  data: function () {
    return {
      lobbies: [],
      openTemplateDropdown: false,
      selectedLobby: {}
    }
  },
  mounted: function () {
    this.fetchLobbies()
  },
  watch: {
  },
  methods: {
    fetchLobbies: function () {
      admin.getVirtualLobbies().then((response) => {
        this.lobbies = response.data.result.lobbies
      })
    },
    goEdit: function () {
      this.$router.push({ name: 'lobbyCreate', params: { existingLobby: this.selectedLobby } })
    },
    goView: function (lobby) {
      this.$router.push(`/2d/${lobby.path}`)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';

</style>
